module.exports = __webpack_public_path__ + "ac1a98f471027c6d9ce67889168016cf.png";